/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Section_QuotaInputs */

const fr_membership_section_quota = /** @type {(inputs: Membership_Section_QuotaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quota`)
};

/**

* @param {Membership_Section_QuotaInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_section_quota = /** @type {((inputs?: Membership_Section_QuotaInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Section_QuotaInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_section_quota(inputs)
});